import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import About from "./about";
import BannerSection from "./banner";
import NewArrivals from "./newArrivals";
import ShopByCategory from "./shopByCategory";
import TrendingNow from "./trendingNow";
import RecommendedForYouSection from "./recommendedForYou";
import DiscountAnnouncement from "./discountAnnouncement";

import Loading from "../loading";


const Home = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (location.pathname === "/") {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
      }, 0);
    }
  }, [location.pathname]);

  useEffect(() => {
    // Simulate loading for all home data (can be replaced with actual data fetching logic)
    const timer = setTimeout(() => setLoading(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[60vh]">
        <Loading showText />
      </div>
    );
  }

  return (
    <div className="sm:w-full lg:w-full md:w-[1440px]">
      <BannerSection />
      <div id="new-arrivals">
        <NewArrivals />
      </div>
      <DiscountAnnouncement />
      <ShopByCategory />
      <TrendingNow />
      <RecommendedForYouSection />
      <div id="about-us">
        <About />
      </div>
    </div>
  );
};

export default Home;
